import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataGridColumns } from 'src/app/interfaces/dagrid-columns';

@Component({
    selector: 'app-grid-config-dialog',
    templateUrl: './grid-config-dialog.component.html',
    styleUrls: ['./grid-config-dialog.component.scss'],
    standalone: false
})
export class GridConfigDialogComponent implements OnInit {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data, 
      public dialogRef:MatDialogRef<GridConfigDialogComponent>,
      private cd:ChangeDetectorRef
    ) { }

  columns:DataGridColumns[];
  displayedColumns:{columnName:string, columnDesc:string}[] = [];
  availableColumns:{columnName:string, columnDesc:string}[] = [];
  
  ngAfterViewInit(){
      this.cd.detectChanges();
  }

  ngOnInit() {

    this.columns = this.data['columns'];

    this.columns.forEach(x=>{

      if ( x.visible ){
        this.displayedColumns.push({columnName:x.columnName, columnDesc:x.columnDesc});
      }else{
        this.availableColumns.push({columnName:x.columnName, columnDesc:x.columnDesc});
      }
    })
  }

  public closeGrid():void{
    this.dialogRef.close();
 }

  /** substitui o [mat-dialog-close] do template migrado para ng-zorro */
  public confirm():void{
    this.dialogRef.close({ columns: this.columns });
  }

  drop(event: CdkDragDrop<{columnName:string, columnDesc:string}[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
        
    }

    let i = 1;
    this.displayedColumns.forEach(x=>{
      let column:DataGridColumns =  this.columns.find(col=>col.columnName == x.columnName);
      column.visible = true;
      column.order = i;
      i++;
    })

    
    this.availableColumns.sort((a:{columnName:string, columnDesc:string},b:{columnName:string, columnDesc:string})=>{
          
      if (a.columnDesc > b.columnDesc  ) return 1;
      if (a.columnDesc < b.columnDesc  ) return -1;
      return 0;
      }
    )


    let z = 10000;
    this.availableColumns.forEach(x=>{
      let column:DataGridColumns =  this.columns.find(col=>col.columnName == x.columnName);
      column.visible = false;
      column.order = z;
      z++;
    })
      
  }

  addall(){
    /*  this.availableColumns.forEach((c,i,a)=>{
        transferArrayItem(this.availableColumns,this.displayedColumns,i,this.displayedColumns.values.length)
      })*/
      let i = 1;
      this.displayedColumns = this.displayedColumns.concat(this.availableColumns);
      this.displayedColumns.forEach(x=>{
        let column:DataGridColumns =  this.columns.find(col=>col.columnName == x.columnName);
        column.visible = true;
        column.order = i;
        i++;
      })
      this.availableColumns=[];  
  }

  removeall(){
    
    this.availableColumns = this.availableColumns.concat(this.displayedColumns);

    this.availableColumns.sort((a:{columnName:string, columnDesc:string},b:{columnName:string, columnDesc:string})=>{
          
        if (a.columnDesc > b.columnDesc  ) return 1;
        if (a.columnDesc < b.columnDesc  ) return -1;
        return 0;
      }
    )

    let i = 10000;
    this.availableColumns.forEach(x=>{
      let column:DataGridColumns =  this.columns.find(col=>col.columnName == x.columnName);
      column.visible = false;
      column.order = i;
      i++;
    })

    this.displayedColumns=[];
  
  }
  
}
